import { lensPath, mergeDeepRight, set } from "ramda";
import { TypeKeys, type UserActionTypes } from "actions/user";

import { RequestStatus } from "types/request";

import type { IUser } from "types/user";

export interface IUserState extends IUser {
  requestStates: {
    userConfirmationRequestStatus: RequestStatus;
    userRequestStatus: RequestStatus;
  };
}

const initialState: IUserState = {
  email: null,
  firstName: null,
  lastName: null,
  requestStates: {
    userConfirmationRequestStatus: RequestStatus.NOT_STARTED,
    userRequestStatus: RequestStatus.NOT_STARTED,
  },
};

function user(
  state: IUserState = initialState,
  action: UserActionTypes
): IUserState {
  switch (action.type) {
    case TypeKeys.RECEIVE_USER: {
      const {
        user: { email, firstName, lastName },
        userRequestStatus,
      } = action;
      return mergeDeepRight(state, {
        email,
        firstName,
        lastName,
        requestStates: { userRequestStatus },
      });
    }

    case TypeKeys.REQUEST_USER:
      return set(
        lensPath(["requestStates", "userRequestStatus"]),
        action.userRequestStatus,
        state
      );

    case TypeKeys.CONFIRMING_USER:
      return set(
        lensPath(["requestStates", "userConfirmationRequestStatus"]),
        action.userConfirmationRequestStatus,
        state
      );

    case TypeKeys.CONFIRMED_USER:
      return set(
        lensPath(["requestStates", "userConfirmationRequestStatus"]),
        action.userConfirmationRequestStatus,
        state
      );

    default:
      return state;
  }
}

export default user;
